import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { EndpointKey } from '../../http/EndpointKey';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
export const getGTKMEndpointKey = state => {
  const getIsAssignedToACQ175VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0175, [ExperimentParameterGroup.Variant_A]);
  const getIsAssignedToACQ177VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  if (getIsAssignedToACQ177VariantA) {
    return EndpointKey.GTKMCompanyInfoACQ177;
  } else if (getIsAssignedToACQ175VariantA) {
    return EndpointKey.GTKMCompanyInfoACQ175;
  }
  return EndpointKey.GTKMCompanyInfo;
};